<template>
  <div class="w-full">
    <el-button
      v-if="manPaymentString"
      size="large"
      plain
      @click="toggleExpand"
      class="mt-4"
    >
      <Icon
        :icon="isExpanded ? 'fa-solid:chevron-up' : 'fa-solid:chevron-down'"
        class="mr-4"
      />
      {{ manPaymentString }}
    </el-button>
    <div
      ref="contentRef"
      :class="{ expand: isExpanded, collapse: !isExpanded }"
      class="flex justify-center overflow-hidden transition-max-height duration-500 ease-in-out mb-4 bg-gray-900 rounded-br-lg rounded-bl-lg w-full mx-auto"
    >
      <div class="flex flex-col">
        <div class="my-4 text-left border p-2 rounded border-gray-400">
          <div
            v-if="
              reviewStore.settings.bankAccountNumber &&
              reviewStore.settings.bankRoutingNumber
            "
            class="text-center text-lg"
          >
            <b> Bank Wire: </b>
            <br />
            To pay by bank wire, please<br />
            send payment to the following account:<br />
            <br />
            <div>
              Account #: <b> {{ reviewStore.settings.bankAccountNumber }} </b>
              <br />
              Routing #: <b>{{ reviewStore.settings.bankRoutingNumber }}</b>
            </div>
            <br />
          </div>
          <br />
          <div
            v-if="reviewStore.settings.zelleEmail"
            class="text-center text-lg"
          >
            <b> QuickPay/Zelle: </b>
            <br />
            To pay by QuickPay/Zelle, please <br />
            send payment to the following email: <br />
            <br />
            Email: {{ reviewStore.settings.zelleEmail }} <br />
            <br />
          </div>
        </div>
        <div class="mt-4">
          <div>
            <input
              type="checkbox"
              id="confirmPaymentCheckbox"
              class="cursor-pointer"
              v-model="paymentConfirmed"
            />
            <label for="confirmPaymentCheckbox">
              <span
                class="text-xl"
                :class="paymentConfirmed ? '' : 'animate-pulse'"
              >
                I have independently sent payment to the above account.
              </span>
            </label>
          </div>
          <el-button
            plain
            type="success"
            size="large"
            class="mt-8 w-80 confirmButton"
            :class="paymentConfirmed ? 'animate-bounce' : ''"
            :disabled="!paymentConfirmed"
            @click="handlePayment"
          >
            <transition name="fade" mode="out-in">
              <div :key="confirmMessage">
                {{ confirmMessage }}
              </div>
            </transition>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { Icon } from "@iconify/vue";
import { useReview } from "@/stores";
import useExpandable from "@/composables/useExpandable";
import api from "@/composables/api";

const reviewStore = useReview();
const { isExpanded, contentRef, toggleExpand } = useExpandable();

const confirmMessage = ref("Click to Confirm Sent Payment");

const manPaymentString = computed(() => {
  if (
    reviewStore.settings.bankAccountNumber &&
    reviewStore.settings.bankRoutingNumber &&
    reviewStore.settings.zelleEmail
  ) {
    return "Bank Wire or QuickPay/Zelle";
  } else if (
    reviewStore.settings.bankAccountNumber &&
    reviewStore.settings.bankRoutingNumber
  ) {
    return "Bank Wire";
  } else if (reviewStore.settings.zelleEmail) {
    return "QuickPay/Zelle";
  } else {
    return "";
  }
});

const paymentConfirmed = ref(false);

const handlePayment = () => {
  confirmMessage.value = "Sending Payment...";
  api(`v1/reviewer/payclaim/${reviewStore.hashId}`)
    .then((response) => {
      confirmMessage.value = "Payment Confirmed!";
      reviewStore.invoiceStatus = "claimed paid";
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (reviewStore.reviewStatus == "new") {
          reviewStore.currentComponent = "ExperienceReview";
        } else {
          reviewStore.currentComponent = "ThankYou";
        }
      }, 1500);
    })
    .catch((error) => {
      console.error(error);
    });
};
</script>
<style scoped>
.el-button.animate-bounce {
  animation-duration: 7s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.confirmButton {
  height: 5rem;
}

/* Custom styles for the checkbox */
#confirmPaymentCheckbox {
  transform: scale(1.5); /* Increase the checkbox size by 50% */
  margin-right: 10px; /* Add some space between the checkbox and the label */
  vertical-align: middle; /* Align the checkbox vertically with the text */
}

/* Optional: adjust the label font size and padding for better alignment */
label {
  font-size: 1rem; /* Adjust font size as necessary */
  vertical-align: middle; /* Align the label text vertically with the checkbox */
}
</style>
